/**
 * @file environment.js
 * @description Utilitários para detectar o ambiente de execução
 */

/**
 * Verifica se está em produção baseado no hostname
 * @returns {boolean} true se estiver em produção, false caso contrário
 */
export const isProduction = () => {
  const hostname = window.location.hostname;
  // Considera produção se NÃO for localhost ou 127.0.0.1
  return !hostname.includes('localhost') && hostname !== '127.0.0.1';
};

/**
 * Verifica se está em desenvolvimento
 * @returns {boolean} true se estiver em desenvolvimento, false caso contrário
 */
export const isDevelopment = () => {
  return !isProduction();
};

/**
 * Retorna o ambiente atual como string
 * @returns {string} 'production' ou 'development'
 */
export const getEnvironment = () => {
  return isProduction() ? 'production' : 'development';
};

